<div class="container-fluid glb-popup">
  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  @if (isSearching) {
    <div class="kbm-search-loading">
      <p-progressSpinner></p-progressSpinner>
    </div>
  }
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <hr>
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row m-0">

        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

        <!-- <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="name" id="name" type="text" pInputText>
          <label for="name">Name</label>
          <span *ngFor="let validation of validationMessages.name">
            <small class="p-invalid"
              *ngIf="form1.get('name').hasError(validation.type) && (form1.get('name').dirty || form1.get('name').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
          optionValue="value" placeholder="Status"></p-dropdown>
          <label for="Status">Status</label>
          <span *ngFor="let validation of validationMessages.status">
            <small class="p-invalid"
              *ngIf="form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)">{{validation.message}}
            </small>
          </span>
        </span>
      </div> -->

      <div class="col-lg-12">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown class="w-100" [options]="properties" formControlName="shortTermRentalId" optionLabel="propertyCode" appendTo="body"
          optionValue="shortTermRentalId" (onChange)="fetchCompendiumShortTermRentalJoinByShortTermRentalId($event)" placeholder="Properties" [filter]="true" filterBy="propertyCode" [showClear]="false"></p-dropdown>
          <label for="shortTermRentalId">Properties</label>
          <!-- <span *ngFor="let validation of validationMessages.shortTermRentalId">
          <small class="p-invalid"
            *ngIf="form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)">{{validation.message}}
          </small>
        </span> -->
      </span>
    </div>


    <!-- <div class="col-lg-12">
    <label for="description"><strong>Description :</strong></label>
    <span class="p-float-label w-100 mb-3">
      <editor formControlName="description" id="description"
                    [init]="{
              							height: 500,
              							base_url: '/tinymce',
              							suffix: '.min',
              							plugins: 'code anchor autolink charmap codesample emoticons image link lists media searchreplace table visualblocks wordcount',
                    toolbar: 'undo redo | blocks fontfamily fontsize | bold italic underline strikethrough | link image media table | align lineheight | numlist bullist indent outdent | emoticons charmap | removeformat'}">
      </editor>
      <span *ngFor="let validation of validationMessages.description">
        <small class="p-invalid"
          *ngIf="form1.get('description').hasError(validation.type) && (form1.get('description').dirty || form1.get('description').touched)">{{validation.message}}
        </small>
      </span>
    </span>
  </div> -->

  <!-- <div *ngIf="compendiumId" class="col-lg-12">
  <span class="p-float-label w-100 mb-3">
    <p-dropdown class="w-100" [options]="filters" (onChange)="selectedFilters($event)" [(ngModel)]="selectedFilter" optionLabel="name"
    optionValue="value" placeholder=""></p-dropdown>
    <label for="selectedFilter">Select Filter</label>
  </span>
</div> -->
@if (isDataLoaded) {
  <p-pickList #pickList [source]="sourceCompendiums" [target]="targetCompendiums" sourceHeader="Available ({{sourceCompendiums.length}})" targetHeader="Selected ({{targetCompendiums.length}})"
    [dragdrop]="true" [responsive]="true" [sourceStyle]="{ height: '30rem' }" [targetStyle]="{ height: '30rem' }"
    filterBy="{{selectedFilter}}" sourceFilterPlaceholder="Search by name" targetFilterPlaceholder="Search by name"
    breakpoint="1400px" (onMoveAllToSource)="moveAllToSource($event)" (onMoveAllToTarget)="moveAllToTarget($event)" (onMoveToTarget)="moveToTarget($event)" (onMoveToSource)="moveToSource($event)">
    <ng-template let-compendium pTemplate="item">
      <div class="flex flex-wrap p-2 align-items-center gap-3">
        <div class="flex-1 flex flex-column gap-2">
          <span class="font-bold">
            {{ compendium?.name }}
          </span>
          <!-- <div class="flex align-products-center gap-2">
          <span>
            {{ property?.adrCity }}
          </span>
        </div> -->
      </div>
      <!-- <span class="font-bold text-900">
      {{ '$' + product.price }}
    </span> -->
  </div>
</ng-template>
</p-pickList>
}

@if (shortTermRentalId) {
  <div>
    @for (targetPropertiesd of [targetProperties]; track targetPropertiesd) {
      <app-compendiums-short-term-rental-join-list  [shortTermRentalId]="shortTermRentalId" [showFilter]="true" [showPagination]="true" [targetPropertyLength]="targetPropertyLength" (reloadProperties)="reloadProperties($event)"></app-compendiums-short-term-rental-join-list>
    }
  </div>
}

</div>
</div>
<hr>
  <div class="row m-0">
    <div class="col-lg-12">
      <div class="btn-group">
        <div class="button-group">
          @if (compendiumId) {
            <button pButton class="btn-delete p-button-outlined p-button-danger"
            (click)="onFormDelete()">Delete</button>
          }
        </div>

        <div class="button-group">
          <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Cancel</button>
          @if (!compendiumId) {
            <button pButton class="btn-addt p-button" (click)="formAdd()">Add</button>
          }

          @if (compendiumId) {
            <button pButton  class="btn-upt p-button" (click)="formUpdate()">Update</button>
          }
        </div>
      </div>
    </div>
  </div>
</div>